export const carouselImages = [
 /*    {
        "imagen" : "./assets/imgs/IMAGEN1.png"
         /* "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png" 
    } ,
    {
        "imagen" : "./assets/imgs/imagen2.jpg"
    },   
     {
        "imagen" : "./assets/imgs/navidad.png"
    },   */
    
    {
        "imagen" : "./assets/imgs/imagen2.jpg"
    },    
     
  
]